import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { canRoleInitiateChatWith } from "Utils/Social/socialRules";

/**
 * Whether the viewer's ACTIVE persona may start contact with a persona of the given role (App
 * ADR-0015: a Merchant or Hunter never brings a Customer into a conversation). Returns the
 * question as a function because the answer depends on whom it is asked about.
 */
export const useCanInitiateChatWith = () => {
  const user = useLoggedInUser();

  return (targetRoleCode: string | null | undefined) =>
    canRoleInitiateChatWith(user?.accessRoleCode, targetRoleCode);
};
